/**
 * Extracts the property name from a selector function.
 * Handles both implicit and explicit return arrow functions.
 *
 * @template T - The type of the object.
 * @param {(obj: T) => any} selector - A lambda function selecting the property.
 * @returns {string} - The name of the selected property.
 * @throws {Error} - If the selector function is invalid or the property name cannot be extracted.
 */
export const nameof = <T>(selector: (obj: T) => any): string => {
  const str = selector.toString().trim();

  // Attempt to match implicit return: 'u => u.password'
  let match = str.match(/=>\s*\w+\.(\w+)/);

  if (!match) {
    // Attempt to match explicit return: 'u => { return u.password; }' or 'function(u) { return u.password; }'
    match = str.match(/return\s+.*\.(\w+);?/);
  }

  if (match?.[1]) {
    return match[1];
  }

  throw new Error('Invalid selector function');
};
